module.exports = __webpack_public_path__ + "index.html";


/*****************
 ** WEBPACK FOOTER
 ** ./~/file-loader?name=[name].[ext]!./src/index.html
 ** module id = 28
 ** module chunks = 0
 **/